import { usePageControls } from '~/api/hooks/useCharts'

/** M12 (C3b T6 dedup): the driver fact's OWN controls + the campaign cold-load gate, shared by
 *  MetricDriverBarsTile and DynamicsPanelsTile. Gate on isPending, NOT data-absence — a settled
 *  fetch error must un-gate (visible degradation, no-silent-fallbacks; see T6 fix-wave). A
 *  disabled query (no driverFact) is isPending forever in v5 — moot, callers AND the gate with
 *  a non-null driverKpi/driverFact.
 */
export function useDriverCampaignGate(driverFact: string | undefined, campaignActive: boolean) {
  const driverControls = usePageControls(driverFact ?? null)
  const driverColdLoad = campaignActive && driverControls.isPending
  return { driverControls, driverColdLoad }
}
